module.exports = __webpack_public_path__ + "static/mediatek-device-30858400e2bcb9c39e6e1b58a44df34a.png";